export enum ApiCallErrorMessages {
  ALREADY_INSURED_OVER = 'ULTIMO_ATTESTATO_DA_AZX_OLTRE_30',
  ALREADY_INSURED_UNDER = 'ULTIMO_ATTESTATO_DA_AZX_ENTRO_30',
  LOWER_DISCOUNT = 'ERRORE_SCONTO_MINORE'
}
